import React, { useEffect } from 'react'
import { faClose} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactModal from 'react-modal'
import { Button, FormHelperText, Grid, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { Store } from 'react-notifications-component'
import './CategoriesModal.scss'
import { createCategory, editCategory } from '../../../../../api/categories'

type Props = {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    categories?: any
    data?: any
    refetch?: any
    edit?: boolean
}
const c = 'categories-modal'

const CategoriesModal = (props: Props) => {
  const {t} = useTranslation()

  const {register, getValues, handleSubmit, setValue, formState: {errors}} = useForm()

  function submit(){
    const params = {
      name: getValues().name,
      ru_name: getValues().ru_name
    }

    if(props.data){
      editCategory(params, props.data?._id).then(() => {
        Store.addNotification({
          title: 'SUCCESS',
          message: 'Success',
          container: 'top-center',
          type: "success",
          insert: "top",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 1000,
            onScreen: true
          }
        })
        props.refetch?.()
      }).catch(() => {
        Store.addNotification({
          title: 'ERROR',
          message: 'Error',
          container: 'top-center',
          type: "danger",
          insert: "top",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 1000,
            onScreen: true
          }
        })
      }).finally(()=>{
        props.setIsOpen(false)
      })
    } else {
      createCategory(params).then(() => {
        Store.addNotification({
          title: 'SUCCESS',
          message: 'Success',
          container: 'top-center',
          type: "success",
          insert: "top",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 1000,
            onScreen: true
          }
        })
        props.refetch?.()
      }).catch(() => {
        Store.addNotification({
          title: 'ERROR',
          message: 'Error',
          container: 'top-center',
          type: "danger",
          insert: "top",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 1000,
            onScreen: true
          }
        })
      }).finally(()=>{
        props.setIsOpen(false)
      })
    }

  }

  useEffect(()=>{
    if(props.data){
      setValue('name', props.data.name)
      setValue('ru_name', props.data?.ru_name)
    }
  },[props.data])

  return (
    <ReactModal className='categories-modal-container' isOpen={props.isOpen}>
      <div className={c}>
        <div className={`${c}-close`}><FontAwesomeIcon icon={faClose} onClick={() => props.setIsOpen(false)}/></div>
        <div className={`${c}-title`}>Categorie</div>
        <form onSubmit={handleSubmit(submit)} className={`${c}__content`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                {...register('name', {required: true})}
                label='Nume'
                error={!!errors.name}
                fullWidth
                variant='outlined'
                size='small'
                inputProps={{
                  style: {
                    borderColor: 'red'
                  }
                }}
              />
              {errors?.name && <FormHelperText error={!!errors?.name} id="component-error-text">{t('FIELD_REQUIRED')}</FormHelperText>}
            </Grid>
            <Grid item xs={12}>
              <TextField
                {...register('ru_name', {required: true})}
                label='Nume (ru)'
                error={!!errors.ru_name}
                fullWidth
                variant='outlined'
                size='small'
                inputProps={{
                  style: {
                    borderColor: 'red'
                  }
                }}
              />
              {errors?.ru_name && <FormHelperText error={!!errors?.ru_name} id="component-error-text">{t('FIELD_REQUIRED')}</FormHelperText>}
            </Grid>
          </Grid>
          <div className={`${c}__content-submit`}>
            <Button
              variant='contained'
              type='submit'
              sx={{
                backgroundColor: '#ff1647',
                textTransform: 'none',
                fontWeight: 'bold',
                width: '100%',
                '&:hover': { backgroundColor: '#cc1138' },
              }}
            >
            Salveaza
            </Button>
          </div>
        </form>
      </div>
    </ReactModal>
  )
}

export default CategoriesModal